import React from 'react';
import Footer from '../../layout/Footer';
import LoginForm from '../../authentication/Login';
import { SessionTimedOutMessage } from '../../components/ui';

const Authentication = () => (
    <>
        <main className='container'>
            <section className='login'>
                <SessionTimedOutMessage />
                <LoginForm />          
            </section>
        </main>
        <Footer />
    </>
)

export default Authentication;